import { api } from "./index"

const DashboardRequestService = {
	getTotalActive(params) {
		return api.get('dashboard/total-active-companies', params)
	},
  getTotalInCurrentProgram(params) {
    return api.get('dashboard/total-in-current-program', params)
  },
	getAcceleratorParticipationIndex(params) {
		return api.get('dashboard/accelerator-participation-index', params)
	},
	getFundValues(params) {
		return api.get('dashboard/fund-values', params)
	},
  getFundValuesElitePass(params) {
		return api.get('dashboard/fund-values-elite-pass', params)
	},	
  getRankingTechnologies(company_id) {
    return api.get(`dashboard/get-ranking-technologies/${company_id}`)
  },	
  getRankingTechnologiesByPos(fiscal_year_id, pos, cancelToken) {
    return api.get(`dashboard/get-ranking-technologies-by-pos/${fiscal_year_id}`,{params:{pos},cancelToken})
  },	
  getTechnologies() {
    return api.get(`dashboard/get-technologies`)
  },	
  getRankingByTechnologies(fiscal_year_id, params, cancelToken) {
    return api.get(`dashboard/get-ranking-by-technologies/${fiscal_year_id}`,{params:params,cancelToken})
  },
  getDataByMonth(params){
    return api.get(`dashboard/get-data-by-month`,{params:params});
  }
}

export default DashboardRequestService